import { rosterAPI } from '@/providers/apis/roster/roster';
import { copy } from '@/utils/cohort';
import { STATUS_CODE_MESSAGE } from '@/utils/constants';
import { isAPICatchError, isEmptyValue } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'enrollment-details',
})

export default class EnrollmentDetails extends Vue {


    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private activeRoster: any;

    @Prop({default: false})
    private showSourceId: any;

    private enrollmentList: any = [];

    private isLoading: boolean = false;

    private statusCode: any = STATUS_CODE_MESSAGE;

    private tableFields: any = [
        // {
        //     key: 'sourcedId',
        //     label: 'Sourced Id',
        // },
        {
            key: 'classTitle',
            label: 'Class',
        },
        {
            key: 'givenName',
            label: 'First name',
        },
        {
            key: 'familyName',
            label: 'Last Name',
        },
        {
            key: 'email',
            label: 'Email',
        },
        {
            key: 'syncStatusCode',
            label: 'Status',
        },
        {
            key: 'role',
            label: 'Role',
        },
        {
            key: 'syncStatusMessage.message',
            label: 'Errors',
        },
        {
            key: 'sourcedId',
            label: 'Sourced Id',
        },
    ];

    private offset: number = 0;

    private limit: number = 10;

    private totalLength: number = 0;

    private currentPage: number = 1;

    private pageLimit: number = 10;

    public get filteredItemList() {
        const tableFields = copy(this.tableFields);
        return tableFields.filter((item: any) => {
            if (this.showSourceId) {
                return tableFields;
            } else {
               return item.key !== 'sourcedId';
            }
        });
    }

    // ---------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.isLoading = true;
        if (!this.activeRoster.showError) {
            const errorIndex = this.tableFields.findIndex((item: any) => item.label === 'Errors');
            if (errorIndex !== -1) {
                this.tableFields.splice(errorIndex, 1);
            }
        }
        this.fetchClasslist();
        this.arrayToObject();
    }

    // ---------------------------------------------------------------------------------
    // Actions

    private onSelectPage(item: any) {
        if (this.enrollmentList.length < item * this.pageLimit) {
            this.isLoading = true;
            this.currentPage = item;
            this.offset = (item - 1) * this.pageLimit;
            this.fetchClasslist();
        }
    }

    // ------------------------------------------------------------------------------
    // Methods

    private fetchClasslist() {
        const params = {
            zipId: this.activeRoster.id,
            offset: this.offset,
            limit: this.limit,
            is_required_sync: this.activeRoster.showError,
        };

        rosterAPI.getEnrollmentDetails(params).then(async (uploadList) => {
            this.isLoading = false;
            if (!isAPICatchError(uploadList)) {
                if (uploadList.enrollments && uploadList.enrollments.length > 0) {
                    await this.mapErrorMessages(uploadList.enrollments);
                }
                this.enrollmentList = uploadList.enrollments;
                this.totalLength = uploadList.totalEnrollmentsCount;
            }
        });
    }

    private async mapErrorMessages(uploadEnroll: any) {
        for await (const iterator of uploadEnroll) {
            if (isEmptyValue(iterator.syncStatusMessage) ||
                isEmptyValue(iterator.syncStatusMessage.message)) {
                iterator.syncStatusMessage = {};
                iterator.syncStatusMessage.message =
                    this.activeRoster.errorMessage[iterator.userSourcedId];
            }
        }
    }

    private arrayToObject() {
        this.activeRoster.errorMessage = {};
        if (this.activeRoster.uploadStatistics.enrollment_errors) {
            this.errorMapping(this.activeRoster.uploadStatistics.enrollment_errors);
        } else if (this.activeRoster.uploadStatistics.users_errors) {
            this.errorMapping(this.activeRoster.uploadStatistics.users_errors);
        }
    }

    private errorMapping(list: any) {
        for (const iterator of list) {
            for (const key in iterator) {
                if (Object.prototype.hasOwnProperty.call(iterator, key)) {
                    this.activeRoster.errorMessage[key] = iterator[key];
                }
            }
        }
    }

}
